 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"album":"album","albums~market":"albums~market","albums":"albums","market":"market","app-nfts":"app-nfts","app-nfts-owned":"app-nfts-owned","assets":"assets","profile-security":"profile-security","community":"community","contact":"contact","earn":"earn","ecosystem":"ecosystem","game-world":"game-world","home":"home","login":"login","metaverse":"metaverse","news":"news","people":"people","profile":"profile","profile-dashboard":"profile-dashboard","profile-details":"profile-details","profile-preferences":"profile-preferences","saga":"saga","signup":"signup","staking":"staking","statuses":"statuses","terms":"terms","welcome":"welcome","ClaimNftModal":"ClaimNftModal","ClaimPhysicalGoodsModal":"ClaimPhysicalGoodsModal","GenerateImageModal":"GenerateImageModal","NtoModal":"NtoModal","SecretMaterialsModal":"SecretMaterialsModal","TicketModal":"TicketModal","ViewContentModal":"ViewContentModal"}[chunkId]||chunkId) + "." + {"album":"da02aa5d6650ebf00dc4","albums~market":"cf3d946fef8947437d13","albums":"be3e9bdaf1350b3c6d3c","market":"c56cf9991136f9c79441","app-nfts":"bbac30a034560ebe85fe","app-nfts-owned":"e4affab4b33085cfa51d","chunk-2d20f576":"c9cf16004c2d4b57d75c","assets":"67dc9411eeccb941d45d","profile-security":"939d17c32d1ba1dbe88a","chunk-2f208b94":"061a9cff3839673aabe9","community":"b5f95a4895696785ae8f","contact":"cabb7e9c8692a0290fa3","earn":"670e32967e4032aa4816","ecosystem":"b8aab8abc480d3e26f94","game-world":"1423e79fdf0f69b7ffc8","home":"31f68aea82c12632ca65","login":"35c4f011c39f6f397ccc","metaverse":"7bcb553df0641a6537b7","news":"30a8f81d1f2902211c25","people":"400421834c28f49940c9","profile":"c012747067af8420a173","profile-dashboard":"9347fc623b056bcbfd64","profile-details":"d94eadc9d299b3eb610c","profile-preferences":"37465d54d9ec3985104b","saga":"d3978ff99c169213879d","signup":"cc8cbc3ba3d18fd9e5f1","staking":"a5255ccd17dcd3c7b1f1","statuses":"206ad958279fda006c22","terms":"fccdbbb446618f6ac98b","welcome":"053631ec3d00f268744e","ClaimNftModal":"fbc74807f2c3c47f37b0","ClaimPhysicalGoodsModal":"56ff068c6e0d784c7358","GenerateImageModal":"4620af4a90d4761529c5","NtoModal":"a399cd9bf564936f95e1","SecretMaterialsModal":"a7b0f52a156130f4b6f5","TicketModal":"bc8bed706e5a73643d28","chunk-7d76d42e":"8a4cf86b1390c2d57dad","chunk-2d0c8f6e":"ec95b245a84dc429b95e","chunk-2d20776a":"f3f4ecead518855d9967","chunk-2d207bc6":"7f1c65e36229d36556e1","chunk-2d22c11d":"519a718449996b30faca","ViewContentModal":"6b3bf3024cb513f0b9d7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"album":1,"albums~market":1,"albums":1,"market":1,"app-nfts":1,"app-nfts-owned":1,"assets":1,"profile-security":1,"community":1,"contact":1,"earn":1,"ecosystem":1,"game-world":1,"home":1,"login":1,"metaverse":1,"news":1,"people":1,"profile":1,"profile-dashboard":1,"profile-details":1,"profile-preferences":1,"saga":1,"signup":1,"staking":1,"statuses":1,"terms":1,"welcome":1,"ClaimNftModal":1,"ClaimPhysicalGoodsModal":1,"GenerateImageModal":1,"NtoModal":1,"SecretMaterialsModal":1,"TicketModal":1,"chunk-7d76d42e":1,"ViewContentModal":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"album":"album","albums~market":"albums~market","albums":"albums","market":"market","app-nfts":"app-nfts","app-nfts-owned":"app-nfts-owned","assets":"assets","profile-security":"profile-security","community":"community","contact":"contact","earn":"earn","ecosystem":"ecosystem","game-world":"game-world","home":"home","login":"login","metaverse":"metaverse","news":"news","people":"people","profile":"profile","profile-dashboard":"profile-dashboard","profile-details":"profile-details","profile-preferences":"profile-preferences","saga":"saga","signup":"signup","staking":"staking","statuses":"statuses","terms":"terms","welcome":"welcome","ClaimNftModal":"ClaimNftModal","ClaimPhysicalGoodsModal":"ClaimPhysicalGoodsModal","GenerateImageModal":"GenerateImageModal","NtoModal":"NtoModal","SecretMaterialsModal":"SecretMaterialsModal","TicketModal":"TicketModal","ViewContentModal":"ViewContentModal"}[chunkId]||chunkId) + "." + {"album":"f0f6e425","albums~market":"e1053a1b","albums":"038f2fd6","market":"40c612c9","app-nfts":"4934e949","app-nfts-owned":"b46435b5","chunk-2d20f576":"31d6cfe0","assets":"dd9cc93d","profile-security":"fef2ace6","chunk-2f208b94":"31d6cfe0","community":"13eebe5f","contact":"1aafa8a2","earn":"3d6b9e73","ecosystem":"b99611f6","game-world":"3dc28f19","home":"8790caca","login":"ef471485","metaverse":"ff9b23b8","news":"dbb953b6","people":"93491c6b","profile":"e21911b1","profile-dashboard":"3cfde933","profile-details":"d829b3be","profile-preferences":"b85e12be","saga":"cd3781dc","signup":"cccc1915","staking":"be66ae6f","statuses":"064cde8e","terms":"8b6718ee","welcome":"e6974e27","ClaimNftModal":"8716cf74","ClaimPhysicalGoodsModal":"83657e7b","GenerateImageModal":"046b4f51","NtoModal":"b479f975","SecretMaterialsModal":"25db7174","TicketModal":"c084b3cf","chunk-7d76d42e":"f7564627","chunk-2d0c8f6e":"31d6cfe0","chunk-2d20776a":"31d6cfe0","chunk-2d207bc6":"31d6cfe0","chunk-2d22c11d":"31d6cfe0","ViewContentModal":"7b2327a3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
